module.exports = __webpack_public_path__ + "static/1-new-57ecb557acbb51c7a5319f0d78c1d498.jpg";